import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import TitleBar from '../utils/TitleBar.js';


function CycleCount(props) {
    const { data } = props;
    const { t } = useTranslation();

    return (
        <div style={{padding: '10px 15px'}}>
            <TitleBar title={t('Cycle Count')} data={data} />
            <div style={{marginTop: '20px'}}>
                <div style={{backgroundColor: '#f0f0f0', width: '100%', borderRadius: '10px',  padding: '4px 4px'}}>
                    <div style={{fontSize: '12px'}}>{t('Cycle Count')}: {data&&data.hasOwnProperty("Count") ? data.Count : '-'}</div>
                </div>
            </div>
        </div>
    );
}

export default CycleCount;
